export default __webpack_public_path__ + "static/media/Royal commencement.ac73039d.jpg";